import React from 'react'

const defaultProps = {
  height: '80',
  width: '80',
}

const IconReport = (props) => {
  const viewBox = `0 0 ${props.height} ${props.width}`
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.height}
      height={props.width}
      viewBox={props.viewBox}
      fill="none"
    >
      <path
        d="M76.25 19.4819C82.4632 19.4819 87.5 24.5187 87.5 30.7319V70.7319C87.5 76.9451 82.4632 81.9819 76.25 81.9819H23.75C17.5368 81.9819 12.5 76.9451 12.5 70.7319V30.7319C12.5 24.5187 17.5368 19.4819 23.75 19.4819H76.25ZM23.75 23.2319C19.6079 23.2319 16.25 26.5898 16.25 30.7319V70.7319C16.25 74.8741 19.6079 78.2319 23.75 78.2319H76.25C80.3921 78.2319 83.75 74.8741 83.75 70.7319V30.7319C83.75 26.5898 80.3921 23.2319 76.25 23.2319H23.75ZM43.7275 36.4233C44.0734 35.6139 45.2215 35.6139 45.5674 36.4233L54.9961 58.4927L58.7744 49.6509C58.9318 49.2828 59.294 49.0444 59.6943 49.0444H72C72.5523 49.0444 73 49.4921 73 50.0444V51.5044C72.9999 52.0566 72.5522 52.5044 72 52.5044H61.3086L55.916 65.1255C55.57 65.9344 54.4232 65.9344 54.0771 65.1255L44.6475 43.0552L40.8701 51.897C40.7128 52.2651 40.3506 52.5044 39.9502 52.5044H28C27.4478 52.5044 27.0001 52.0566 27 51.5044V50.0444C27 49.4921 27.4477 49.0444 28 49.0444H38.3359L43.7275 36.4233Z"
        fill="#FFFFFF"
      />
    </svg>
  )
}

IconReport.defaultProps = defaultProps

export default IconReport
